export const ANIMATION_DURATION = 0.6;
export const DELAY_DURATION = 0.25;
